import { tabs } from 'data/constants';
import { ActiveTabType } from 'data/types';
import { ReactNode } from 'react';

export type SidePanelTab = {
  id: string;
  label: string;
  isLoading?: boolean;
  disabled?: boolean;
  summary?: string;
  complete?: boolean;
  renderContent: () => ReactNode;
};

export type NavigationDirection = 'forward' | 'backward' | 'same';

export const getNavigationDirection = (
  currentTab: ActiveTabType,
  previousTab: ActiveTabType | null
): NavigationDirection => {
  if (!previousTab || previousTab === currentTab) {
    return 'same';
  }

  const currentIndex = tabs.indexOf(currentTab);
  const previousIndex = tabs.indexOf(previousTab);

  return previousIndex < currentIndex ? 'forward' : 'backward';
};

export const getStructureTabForStep = (stepId: string): string | null => {
  if (stepId === 'configure_level_details') {
    return 'levels';
  }
  if (stepId === 'images') {
    return 'images';
  }
  if (
    stepId === 'add_spaces' ||
    stepId === 'condenser_locations' ||
    stepId === 'orientation'
  ) {
    return 'spaces';
  }
  if (stepId === 'space_details') {
    return 'space_details';
  }
  return null;
};

export const getConfigurationTabForStep = (stepId: string): string | null => {
  if (stepId.startsWith('add_spaces_zone_')) {
    return 'zones';
  }
  if (stepId === 'condensers') {
    return 'condensers';
  }
  if (stepId === 'air_handlers') {
    return 'air_handlers';
  }
  if (stepId === 'line_sets') {
    return 'line_sets';
  }
  return null;
};
